import { loadStripe } from '@stripe/stripe-js';
import appConfigData from '../appConfig.json';

// Load Stripe publishable key from appConfig
const stripePromise = loadStripe((appConfigData as any).STRIPE_PUBLISHABLE_KEY);

export default stripePromise;